import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'nc-blur-text',
	templateUrl: './blur-text.component.html',
	styleUrls: ['./blur-text.component.less']
})
export class BlurTextComponent implements OnInit {
	@Input() ncText: string = '';
	@Input() ncBlurColor: string = 'inherit';
	private _hover: boolean = false;
	@Input()
	set ncHover(val: boolean | string) {
		this._hover = val !== null && val !== undefined && val !== false && val !== 'false';
	}
	get ncHover(): boolean {
		return this._hover;
	}
	private _lockIcon: boolean = false;
	@Input()
	set ncLockIcon(val: boolean | string) {
		this._lockIcon = val !== null && val !== undefined && val !== false && val !== 'false';
	}
	get ncLockIcon(): boolean {
		return this._lockIcon;
	}

	constructor() { }

	ngOnInit(): void {
	}

}
